export const SET_COUNTRIES = 'SET_COUNTRIES'
export const SET_STATES = 'SET_STATES'
export const actions = {
  setCountries: payload => ({ type: SET_COUNTRIES, payload }),
  setStates: payload => ({ type: SET_STATES, payload }),
}
